<template>
    <div v-if="asyncDataStatus_ready">

    <v-row>
      <v-breadcrumbs :items="breadcrumbs" divider=">" style="padding: 12px">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="businessUnits.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'ClientsBusinessUnitsNew', params: { childCompanyId: childCompanyId }})"
        >
          Nova poslovna enota
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="businessUnits.length">
      <v-col
        cols="12" md="6" lg="4" xl="3"
        v-for="item of filteredBusinessUnits" :key="item.id"
      >
        <BusinessUnitCard
          :businessUnit="item"
          :childCompanyId="childCompanyId"
          @edit="$router.push({name: 'ClientsBusinessUnitsEdit', params: { childCompanyId: childCompanyId, businessUnitId: item.id }})"
          @devices="$router.push({name: 'ClientsBusinessUnitsDevices', params: { childCompanyId: childCompanyId, businessUnitId: item.id }})"
          @invoices="$router.push({name: 'ClientsBusinessUnitsInvoices', params: { childCompanyId: childCompanyId, businessUnitId: item.id }})"
          @delete="showDeleteBusinessUnitModal = true; deleteBusinessUnit = item"
          @toggleRegistered="activateBusinessUnitModal = item; showActivateBusinessUnitModal = true"
          @toggleDelovniCas="activateBusinessUnitModal = item; toggleDelovniCas()"
          @toggleOrdering="activateBusinessUnitModal = item; toggleOrdering()"
          @toggleTables="activateBusinessUnitModal = item; toggleTables()"
          @togglePricing="activateBusinessUnitModal = item; togglePricing()"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove poslovne enote uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje poslovne enote"
      text="Ali ste prepričani, da želite izbrisati poslovno enoto? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteBusinessUnitModal"
      @confirmed="remove(deleteBusinessUnit)"
    />
    <PopupToggleBusinessUnitActiveStatus
      :active="activateBusinessUnitModalIsActive"
      v-model="showActivateBusinessUnitModal"
      @confirmed="toggleRegistered"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import ConfirmDialog from '@/components/ConfirmDialog'
import BusinessUnitCard from '@/components/BusinessUnitCard'
import PopupToggleBusinessUnitActiveStatus from '@/components/PopupToggleBusinessUnitActiveStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    BusinessUnitCard,
    PopupToggleBusinessUnitActiveStatus
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      filter: '',
      showDeleteBusinessUnitModal: false,
      deleteBusinessUnit: null,
      showActivateBusinessUnitModal: false,
      activateBusinessUnitModal: null,
      breadcrumbs: [
        {
          text: 'Stranke',
          disabled: false,
          href: '/clients'
        },
        {
          text: 'Poslovne enote',
          disabled: false,
          href: '/clients/' + this.childCompanyId + '/business-units'
        }
      ]
    }
  },
  computed: {
    businessUnits () {
      return objectToArray(this.$store.state.clientsBusinessUnits.items)
    },
    filteredBusinessUnits () {
      return this.businessUnits.filter(item => siIncludes({ haystack: `${item.name}`, needle: this.filter }))
    },
    activateBusinessUnitModalIsActive () {
      if (!this.activateBusinessUnitModal || !this.activateBusinessUnitModal.register_date) return false
      return true
    }
  },
  methods: {
    ...mapActions('clientsBusinessUnits', ['loadItems', 'deleteItem', 'updateRegistered']),
    ...mapActions('companies', ['vrniCompanyIdentity']),
    ...mapActions('delovnicas', ['statusDelovnegaCasaDistributer']),
    ...mapActions('businessUnits', ['statusOrdering', 'statusTables', 'enableBusinessUnitPricing', 'disableBusinessUnitPricing']),
    remove (item) {
      this.deleteItem({ childCompanyId: this.childCompanyId, businessUnitId: item.id })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    },
    toggleRegistered (form) {
      this.updateRegistered({
        childCompanyId: this.childCompanyId,
        data: {
          id: this.activateBusinessUnitModal.id,
          special_notes: form.notes,
          validity_date: this.$moment().toISOString(),
          close: this.activateBusinessUnitModalIsActive,
          ignore_devices: this.activateBusinessUnitModalIsActive ? true : false
        }
      })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    },
    toggleDelovniCas () {
      this.vrniCompanyIdentity(this.childCompanyId)
        .then(resp => {
          const businessUnitId = this.activateBusinessUnitModal.id
          const statusprej = !this.activateBusinessUnitModal.work_time
          const status = statusprej === false ? 0 : 1
          const headers = {
            Authorization: `Bearer ${resp.token}`
          }
          this.statusDelovnegaCasaDistributer({ businessUnitId, status, headers })
            .then(resp => {
              /* this.$notify({
                type: 'success',
                text: 'Podatki so bili uspešno shranjeni.'
              }) */
              this.activateBusinessUnitModal.work_time = statusprej
            })
        })
    },
    toggleOrdering () {
      this.vrniCompanyIdentity(this.childCompanyId)
        .then(resp => {
          const businessUnitId = this.activateBusinessUnitModal.id
          const statusprej = !this.activateBusinessUnitModal.ordering
          const status = statusprej === false ? 0 : 1
          const headers = {
            Authorization: `Bearer ${resp.token}`
          }
          this.statusOrdering({ businessUnitId, status, headers })
            .then(resp => {
              /* this.$notify({
                type: 'success',
                text: 'Podatki so bili uspešno shranjeni.'
              }) */
              this.activateBusinessUnitModal.ordering = statusprej
            })
        })
    },
    toggleTables () {
      this.vrniCompanyIdentity(this.childCompanyId)
        .then(resp => {
          const businessUnitId = this.activateBusinessUnitModal.id
          const statusprej = !this.activateBusinessUnitModal.table_work
          const status = statusprej === false ? 0 : 1
          const headers = {
            Authorization: `Bearer ${resp.token}`
          }
          this.statusTables({ businessUnitId, status, headers })
            .then(resp => {
              /* this.$notify({
                type: 'success',
                text: 'Podatki so bili uspešno shranjeni.'
              }) */
              this.activateBusinessUnitModal.table_work = statusprej
            })
        })
    },
    togglePricing () {
      this.vrniCompanyIdentity(this.childCompanyId)
      .then(resp => {
          const businessUnitId = this.activateBusinessUnitModal.id
          const statusprej = this.activateBusinessUnitModal.pricing
          const headers = {
            Authorization: `Bearer ${resp.token}`
          }
          if (!statusprej) {
            this.enableBusinessUnitPricing({ businessUnitId, headers })
              .then(resp => {
                this.activateBusinessUnitModal.pricing = !statusprej
              })
          } else {
            this.disableBusinessUnitPricing({ businessUnitId, headers })
              .then(resp => {
                this.activateBusinessUnitModal.pricing = !statusprej
              })
          }
        })
    }
  },
  created () {
    this.loadItems({ childCompanyId: this.childCompanyId })
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
